import type * as core from '../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.research.idc.complete.basic',
    'resource:solutions.apps.rate.pages.gl',
    'resource:solutions.apps.rate.pages.report',
    'resource:solutions.apps.rate.pages.reports',
    'resource:solutions.apps.rate.pages.rules',
    'resource:solutions.apps.rate',
  ],
  description: 'Indirect cost proposal application',
  name: 'Rate',
} as const satisfies core.quiver.Package
